module.exports = __webpack_public_path__ + "static/media/daycareBanner1.b18bfc17.png";